<script lang="ts">
  import { ErrorState, LoadingState } from '../../../shared/ui';
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { useInventorySettings } from '../api/inventory-api';
  import ThresholdsForm from './ThresholdsForm.svelte';

  /** Settings: the two expiry thresholds of the clinic (BR-10). */
  const org = useOrg();
  const settings = useInventorySettings(org.orgId);
</script>

{#if settings.isPending}
  <LoadingState variant="form" />
{:else if settings.isError}
  <ErrorState error={settings.error} onRetry={() => void settings.refetch()} />
{:else}
  {#key `${settings.data.expiryAlertDays}:${settings.data.expiryWarnDays}`}
    <ThresholdsForm initial={settings.data} />
  {/key}
{/if}
